export default __webpack_public_path__ + "static/media/Checkmark.e04c893d.svg";